// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShoppingTwoToneSvg from "@ant-design/icons-svg/es/asn/ShoppingTwoTone";
import AntdIcon from '../components/AntdIcon';

var ShoppingTwoTone = function ShoppingTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingTwoToneSvg
  }));
};

ShoppingTwoTone.displayName = 'ShoppingTwoTone';
export default React.forwardRef(ShoppingTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ShoppingTwoTone.js
// module id = 1797
// module chunks = 0